import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Form, InputGroup } from "react-bootstrap";
import Select from "react-select";
import RequiredLabel from "../../CustomCommons/RequiredLabel";
import { BASE_URL } from "../../Const/Url";
import { showToast } from "../../../utils/ToastHelper";
import SelectOpenWithPagginationDynamic from "../../Const/SelectOpenWithPagginationDynamic";
import { handleSelectAll } from "../../Const/Status";
import { logout_func2 } from "../../Const/logoutCommon";

const CreateNavItem = () => {
  const history = useHistory();
  const [title, setTitle] = useState("");
  const [order, setOrder] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isOffer, setIsOffer] = useState(false);
  const [isFestival, setIsFestival] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [productList, setProductsList] = useState([]);
  const [inputQuery, setInputQuery] = useState("");
  const [contentType, setContentType] = useState(0); // 0 = Product, 1 = Category, 2 = None, 3 = Both

  const [categoryQuery, setCategoryQuery] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [, setOnlogoutHide] = useState(0);

  const handleProductChange = (newValue) => {
    setSelectedProducts(newValue);
  };

  const handleProductInput = (inputValue) => {
    setInputQuery(inputValue);
  };

  const handleOfferToggle = (checked) => {
    setIsOffer(checked);
    if (checked || isFestival) {
      setContentType(2);
    }
  };

  const handleFestivalToggle = (checked) => {
    setIsFestival(checked);
    if (checked || isOffer) {
      setContentType(2);
    }
  };

  const getCategories = (query = "") => {
    const params = new URLSearchParams();
    params.append("limit", 20);
    params.append("is_website", true);
    if (query) {
      params.append("query", query);
    }

    axios
      .get(
        `${BASE_URL}api/v1/inventory/inventory/category/?${params.toString()}`
      )
      .then((res) => {
        const results = res?.data?.data?.results || [];
        const formatted = results.map((item) => ({
          label: item?.name,
          value: item?.id,
        }));
        setCategoryOptions(formatted);
      })
      .catch(() => {});
  };

  useEffect(() => {
    const debounce = setTimeout(() => {
      getCategories(categoryQuery);
    }, 300);
    return () => clearTimeout(debounce);
  }, [categoryQuery]);

  const validateForm = () => {
    const effectiveContentType = !isOffer && !isFestival ? contentType : 2;

    if (!title.trim()) {
      showToast("error", "Title is required.");
      return false;
    }
    if (!order) {
      showToast("error", "Order is required.");
      return false;
    }
    if (
      effectiveContentType === 1 &&
      !selectedCategories.length &&
      !isOffer &&
      !isFestival
    ) {
      showToast("error", "Please select at least one category.");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (!validateForm()) return;

    const effectiveContentType = !isOffer && !isFestival ? contentType : 2;

    const payload = {
      title: title.trim(),
      order: Number(order),
      is_active: isActive,
      is_offer: isOffer,
      is_festival: isFestival,
      content_type: Number(effectiveContentType),
      products: [],
      categories: [],
    };

    // If type is Product (0): send selected products, always send categories as empty array
    if (effectiveContentType === 0) {
      payload.products = selectedProducts.length
        ? selectedProducts.map((product) => product.value)
        : [];
      payload.categories = [];
    }

    // If type is Category (1): send selected categories, always send products as empty array
    if (effectiveContentType === 1) {
      payload.categories = selectedCategories.length
        ? selectedCategories.map((cat) => cat.value)
        : [];
      payload.products = [];
    }

    // If type is Both (3): send both selected products and categories
    if (effectiveContentType === 3) {
      payload.products = selectedProducts.length
        ? selectedProducts.map((product) => product.value)
        : [];
      payload.categories = selectedCategories.length
        ? selectedCategories.map((cat) => cat.value)
        : [];
    }

    setIsSubmitting(true);
    axios
      .post(`${BASE_URL}api/v1/frontend/admin/v2/navbar/`, payload)
      .then(() => {
        showToast("success", "Nav item created successfully.");
        history.push("/website-settings/nav-item-list");
      })
      .catch((err) => {
        const status = err?.response?.status;
        if (status === 401) {
          logout_func2(setOnlogoutHide, history);
          return;
        }
        const message =
          err?.response?.data?.errors?.non_field_errors?.[0] ||
          err?.response?.data?.message ||
          "Failed to create navigation item. Please try again.";
        showToast("error", message);
      })
      .finally(() => setIsSubmitting(false));
  };

  const handleCancel = () => {
    history.push("/website-settings/nav-settings");
  };

  return (
    <div className="categorey-parent new-categorey-parent an">
      <div className="bg-white add-div">
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ padding: "20px 35px", border: "0.5px solid #E0E0E0" }}
        >
          <h3 style={{ fontSize: "23px", marginTop: "6px" }}>
            Create Navigation Item
          </h3>
        </div>

        <div
          style={{
            padding: "20px 35px",
            borderBottom: "0.5px solid #E0E0E0",
            borderRight: "0.5px solid #E0E0E0",
            borderLeft: "0.5px solid #E0E0E0",
          }}
          className="row"
        >
          <div className="col-12 col-md-6">
            <RequiredLabel text="Title" />
            <InputGroup className="mb-3" style={{ height: "47px" }}>
              <Form.Control
                aria-label="Title"
                aria-describedby="title-input"
                style={{ backgroundColor: "#FAFAFA" }}
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </InputGroup>
          </div>

          <div className="col-12 col-md-6">
            <RequiredLabel text="Order" />
            <InputGroup className="mb-3" style={{ height: "47px" }}>
              <Form.Control
                aria-label="Order"
                aria-describedby="order-input"
                style={{ backgroundColor: "#FAFAFA" }}
                value={order}
                type="number"
                min={0}
                onChange={(e) => setOrder(e.target.value)}
              />
            </InputGroup>
          </div>

          {!isOffer && !isFestival && (
            <div className="col-12 col-md-6">
              <RequiredLabel text="Content Type" />
              <Form.Select
                className="mb-3"
                value={contentType}
                onChange={(e) => setContentType(Number(e.target.value))}
                style={{ height: "47px", backgroundColor: "#FAFAFA" }}
              >
                <option value={0}>Product</option>
                <option value={1}>Category</option>
                <option value={2}>None</option>
                <option value={3}>Both</option>
              </Form.Select>
            </div>
          )}

          {!isOffer && !isFestival && contentType === 0 && (
            <div className="col-12 mt-3">
              <RequiredLabel text="Products (Optional)" />
              <div className="position-relative">
                <SelectOpenWithPagginationDynamic
                  handleMultiInputChange={handleProductChange}
                  inputProduct={handleProductInput}
                  ProductsList={productList}
                  defaultValue={selectedProducts}
                  setProductsList={setProductsList}
                  inputQuery={inputQuery}
                  selectAll={() =>
                    handleSelectAll(productList, setSelectedProducts)
                  }
                  url1={`api/v1/inventory/inventory/product_list_for_offer/?is_website=true&is_admin=false&is_outlet=false&limit=20`}
                  url2={`api/v1/inventory/inventory/product_list_for_offer/?query=${inputQuery}&is_website=true&is_admin=false&is_outlet=false&limit=20`}
                />
              </div>
            </div>
          )}

          {!isOffer && !isFestival && contentType === 1 && (
            <div className="col-12 mt-3">
              <RequiredLabel text="Categories" />
              <div className="position-relative">
                <Select
                  isMulti
                  placeholder="Select categories"
                  value={selectedCategories}
                  onChange={(value) => setSelectedCategories(value || [])}
                  onInputChange={(value) => setCategoryQuery(value)}
                  options={categoryOptions}
                />
              </div>
            </div>
          )}

          {!isOffer && !isFestival && contentType === 3 && (
            <>
              <div className="col-12 mt-3">
                <RequiredLabel text="Products (Optional)" />
                <div className="position-relative">
                  <SelectOpenWithPagginationDynamic
                    handleMultiInputChange={handleProductChange}
                    inputProduct={handleProductInput}
                    ProductsList={productList}
                    defaultValue={selectedProducts}
                    setProductsList={setProductsList}
                    inputQuery={inputQuery}
                    selectAll={() =>
                      handleSelectAll(productList, setSelectedProducts)
                    }
                    url1={`api/v1/inventory/inventory/product_list_for_offer/?is_website=true&is_admin=false&is_outlet=false&limit=20`}
                    url2={`api/v1/inventory/inventory/product_list_for_offer/?query=${inputQuery}&is_website=true&is_admin=false&is_outlet=false&limit=20`}
                  />
                </div>
              </div>
              <div className="col-12 mt-3">
                <RequiredLabel text="Categories (Optional)" />
                <div className="position-relative">
                  <Select
                    isMulti
                    placeholder="Select categories"
                    value={selectedCategories}
                    onChange={(value) => setSelectedCategories(value || [])}
                    onInputChange={(value) => setCategoryQuery(value)}
                    options={categoryOptions}
                  />
                </div>
              </div>
            </>
          )}

          <div className="col-12 mt-4">
            <h5>Status</h5>
            <p style={{ color: "#8E8E93" }}>( Toggle navigation visibility )</p>
            <div
              className="d-flex justify-content-between align-items-center py-3 px-3"
              style={{ backgroundColor: "#F2F2F7", borderRadius: "8px" }}
            >
              <div className="d-flex align-items-center">
                <span className="mx-2">{isActive ? "Active" : "Inactive"}</span>
              </div>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                />
              </div>
            </div>
          </div>

          <div className="col-12 mt-4">
            <h5>Offer & Festival</h5>
            <p style={{ color: "#8E8E93" }}>
              ( Keep both toggles aligned on the same line )
            </p>
            <div
              className="d-flex gap-3 flex-wrap flex-md-nowrap"
              style={{ alignItems: "stretch" }}
            >
              <div
                className="d-flex justify-content-between align-items-center py-3 px-3 flex-grow-1"
                style={{ backgroundColor: "#F2F2F7", borderRadius: "8px" }}
              >
                <div className="d-flex align-items-center">
                  <span className="mx-2">Offer</span>
                </div>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={isOffer}
                    onChange={(e) => handleOfferToggle(e.target.checked)}
                  />
                </div>
              </div>
              <div
                className="d-flex justify-content-between align-items-center py-3 px-3 flex-grow-1"
                style={{ backgroundColor: "#F2F2F7", borderRadius: "8px" }}
              >
                <div className="d-flex align-items-center">
                  <span className="mx-2">Festival</span>
                </div>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={isFestival}
                    onChange={(e) => handleFestivalToggle(e.target.checked)}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="mt-4">
            <button
              onClick={handleSubmit}
              className="save-btn me-2 mt-2"
              style={{ background: "#000", color: "white" }}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Saving..." : "Save"}
            </button>
            <button
              onClick={handleCancel}
              className="save-btn mt-2"
              style={{ border: ".4px solid #E0E0E0 !important" }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateNavItem;
